import React, { useEffect, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";

const ALL = "Todos";

const agenciasCierre = [
  { agencia: "Nissan Aragón", unidades: 126, financiamiento: 87, contado: 39, penetracion: 69, utilidad: 1644408.19, ppto: 112, departamento: "Nuevos", razonSocial: "Spanicar Mexico" },
  { agencia: "Nissan Texcoco", unidades: 111, financiamiento: 84, contado: 27, penetracion: 76, utilidad: 1431433.76, ppto: 95, departamento: "Nuevos", razonSocial: "Spanicar Mexico" },
  { agencia: "MG Tollocan", unidades: 98, financiamiento: 68, contado: 30, penetracion: 69, utilidad: 1379280.49, ppto: 132, departamento: "Nuevos", razonSocial: "Transace S.A de C.V" },
  { agencia: "Nissan Santa Clara", unidades: 107, financiamiento: 84, contado: 23, penetracion: 79, utilidad: 1270959.25, ppto: 89, departamento: "Nuevos", razonSocial: "Spanicar Mexico" },
  { agencia: "MG Ecatepec", unidades: 58, financiamiento: 68, contado: -10, penetracion: 117, utilidad: 939229.44, ppto: 96, departamento: "Nuevos", razonSocial: "Transace S.A de C.V" },
  { agencia: "MG Metepec", unidades: 77, financiamiento: 50, contado: 27, penetracion: 65, utilidad: 917476.65, ppto: 106, departamento: "Nuevos", razonSocial: "Transace S.A de C.V" },
  { agencia: "Nissan Tecamac", unidades: 71, financiamiento: 48, contado: 23, penetracion: 68, utilidad: 837553.59, ppto: 92, departamento: "Nuevos", razonSocial: "Spanicar Mexico" },
  { agencia: "Renault Universidad", unidades: 86, financiamiento: 64, contado: 22, penetracion: 74, utilidad: 761729.56, ppto: 94, departamento: "Nuevos", razonSocial: "Eurofrance Motors" },
  { agencia: "Honda Metepec", unidades: 39, financiamiento: 27, contado: 12, penetracion: 69, utilidad: 753441.39, ppto: 92, departamento: "Nuevos", razonSocial: "Caminos del Sol Santa Fe" },
  { agencia: "Volkswagen", unidades: 78, financiamiento: 37, contado: 41, penetracion: 47, utilidad: 719078.96, ppto: 58, departamento: "Nuevos", razonSocial: "León Motors" },
  { agencia: "Honda Tollocan", unidades: 35, financiamiento: 24, contado: 11, penetracion: 69, utilidad: 597691.9, ppto: 76, departamento: "Nuevos", razonSocial: "Caminos del Sol Santa Fe" },
  { agencia: "Honda Santa Fe", unidades: 49, financiamiento: 16, contado: 33, penetracion: 33, utilidad: 591516.98, ppto: 104, departamento: "Nuevos", razonSocial: "Caminos del Sol Santa Fe" },
  { agencia: "Renault San Ángel", unidades: 69, financiamiento: 38, contado: 31, penetracion: 55, utilidad: 437756.69, ppto: 64, departamento: "Nuevos", razonSocial: "Eurofrance Motors" },
  { agencia: "Seat", unidades: 29, financiamiento: 23, contado: 6, penetracion: 79, utilidad: 415392, ppto: 72, departamento: "Nuevos", razonSocial: "León Motors" },
  { agencia: "Chirey Ecatepec", unidades: 40, financiamiento: 28, contado: 12, penetracion: 70, utilidad: 342343, ppto: 85, departamento: "Nuevos", razonSocial: "Gocar Oriente" },
  { agencia: "Cupra", unidades: 11, financiamiento: 9, contado: 2, penetracion: 82, utilidad: 180130.48, ppto: 80, departamento: "Nuevos", razonSocial: "León Motors" },
  { agencia: "Seminuevos Gocar Bajio", unidades: 12, financiamiento: 7, contado: 5, penetracion: 58, utilidad: 149369.63, ppto: 76, departamento: "Seminuevos", razonSocial: "Gocar Bajio" },
];

const productos = [
  { producto: "Financiamiento", utilidad: 5137844.13, cantidad: 744, penetracion: 69 },
  { producto: "Edega", utilidad: 1623908.58, cantidad: 607, penetracion: 55 },
  { producto: "Seguro Venta", utilidad: 1557612.59, cantidad: 776, penetracion: 70 },
  { producto: "Seguros Renovaciones", utilidad: 1290053.61, cantidad: 451, penetracion: 36 },
  { producto: "Nota Única", utilidad: 1168221.69, cantidad: 20, penetracion: 2 },
  { producto: "Bono penetración", utilidad: 1152761.8, cantidad: 286, penetracion: 26 },
  { producto: "Accesorios", utilidad: 784704.05, cantidad: 557, penetracion: 53 },
  { producto: "Bono", utilidad: 383043.24, cantidad: 7, penetracion: 1 },
  { producto: "Localizador Satelital", utilidad: 111046.39, cantidad: 49, penetracion: 4 },
  { producto: "Garantía Extendida", utilidad: 89508.27, cantidad: 23, penetracion: 2 },
  { producto: "Trámites placas", utilidad: 72623.49, cantidad: 41, penetracion: 2 },
  { producto: "Otras Coberturas", utilidad: 26798.49, cantidad: 49, penetracion: 4 },
];

const brokers = [
  { broker: "NR FINANCE", utilidad: 6164934.38, cantidad: 1675 },
  { broker: "CETELEM", utilidad: 1244950.53, cantidad: 248 },
  { broker: "EDEGA", utilidad: 914842.16, cantidad: 361 },
  { broker: "BBVA", utilidad: 613479.9, cantidad: 154 },
  { broker: "BANORTE", utilidad: 535610.57, cantidad: 96 },
  { broker: "ORDAS", utilidad: 490567.31, cantidad: 144 },
  { broker: "MARSH", utilidad: 434594.29, cantidad: 136 },
  { broker: "VWFS", utilidad: 349334.89, cantidad: 47 },
];

const otrosMensual = [
  { mes: "Enero", anio: "2026", unidades: 86, productos: 283, utilidad: 1257337, ppto: 105, ticketSBono: 9284.63, ticketCBonos: 14620, crecimiento: 12.93 },
  { mes: "Febrero", anio: "2026", unidades: 64, productos: 203, utilidad: 874923, ppto: 93, ticketSBono: 7107.64, ticketCBonos: 13671, crecimiento: 41.15 },
  { mes: "Marzo", anio: "2026", unidades: 66, productos: 286, utilidad: 1086228.71, ppto: 128, ticketSBono: 10219.72, ticketCBonos: 16458, crecimiento: 34.28 },
  { mes: "Abril", anio: "2026", unidades: 69, productos: 204, utilidad: 755260, ppto: 79, ticketSBono: 5498.99, ticketCBonos: 10946, crecimiento: -15.14 },
];

const conceptosOtros = [
  { concepto: "Financiamiento", utilidad: 379228, productos: 72 },
  { concepto: "Seguros", utilidad: 105009.71, productos: 70 },
  { concepto: "Accesorios", utilidad: 66832, productos: 84 },
  { concepto: "Edegas", utilidad: 64185, productos: 30 },
  { concepto: "Localizador Gps", utilidad: 42057, productos: 16 },
  { concepto: "Trámites", utilidad: 11150, productos: 7 },
  { concepto: "O. Coberturas", utilidad: 6040, productos: 7 },
];

const asesoresRanking = [
  { asesor: "VENTA CASA", productos: 96, participacion: 2.6, utilidad: 276451.31, agencia: "Cupra" },
  { asesor: "(F&I Honda Metepec) Patricia Martínez", productos: 73, participacion: 2.24, utilidad: 238601, agencia: "Honda Metepec" },
  { asesor: "Otro Asesor", productos: 64, participacion: 1.16, utilidad: 123496.81, agencia: "MG Tollocan" },
  { asesor: "Rocio Beltran", productos: 46, participacion: 1.41, utilidad: 150377, agencia: "Honda Tollocan" },
  { asesor: "SANDRA HERNANDEZ ESPINOSA", productos: 41, participacion: 0.75, utilidad: 80296.07, agencia: "Nissan Aragón" },
  { asesor: "DURAN LOPEZ ANGELES EDITH", productos: 39, participacion: 0.77, utilidad: 81942.45, agencia: "Nissan Aragón" },
  { asesor: "ARTURO ALFARO CASTILLO", productos: 36, participacion: 0.97, utilidad: 102898.66, agencia: "MG Tollocan" },
  { asesor: "MONTSERRATH SUAREZ", productos: 36, participacion: 1.11, utilidad: 118248.94, agencia: "MG Tollocan" },
  { asesor: "RODRIGO IGNACIO BERNAL VELAZQUEZ", productos: 35, participacion: 0.76, utilidad: 80759.99, agencia: "MG Tollocan" },
  { asesor: "GABRIEL YAÑEZ MENDOZA", productos: 33, participacion: 0.98, utilidad: 103803.84, agencia: "MG Tollocan" },
];

const vehiculosRanking = [
  { vehiculo: "MAGNITE", productos: 497, agencia: "Chirey Ecatepec" },
  { vehiculo: "SEMINUEVO", productos: 280, agencia: "Honda Metepec" },
  { vehiculo: "KICKS", productos: 205, agencia: "Nissan Aragón" },
  { vehiculo: "VERSA", productos: 129, agencia: "Nissan Aragón" },
  { vehiculo: "MARCH", productos: 104, agencia: "Nissan Aragón" },
  { vehiculo: "MG 5 1.5L STD STYLE MT", productos: 95, agencia: "MG Metepec" },
  { vehiculo: "Renault koleos", productos: 86, agencia: "Renault San Ángel" },
  { vehiculo: "MG5 1.5L STD STYLE MT", productos: 83, agencia: "MG Tollocan" },
  { vehiculo: "Renault Arkana", productos: 80, agencia: "Renault San Ángel" },
  { vehiculo: "RENAULT KWID", productos: 80, agencia: "Renault San Ángel" },
];

const pmaMensual = [
  { mes: "Enero", unidades2025: 1268, unidades2026: 1197, pen2025: 59, pen2026: 79 },
  { mes: "Febrero", unidades2025: 949, unidades2026: 1000, pen2025: 69, pen2026: 74 },
  { mes: "Marzo", unidades2025: 930, unidades2026: 1078, pen2025: 76, pen2026: 79 },
  { mes: "Abril", unidades2025: 888, unidades2026: 998, pen2025: 59, pen2026: 70 },
  { mes: "Mayo", unidades2025: 899, unidades2026: 0, pen2025: 70, pen2026: 0 },
  { mes: "Junio", unidades2025: 934, unidades2026: 0, pen2025: 73, pen2026: 0 },
  { mes: "Julio", unidades2025: 1140, unidades2026: 0, pen2025: 65, pen2026: 0 },
  { mes: "Agosto", unidades2025: 1006, unidades2026: 0, pen2025: 69, pen2026: 0 },
  { mes: "Septiembre", unidades2025: 957, unidades2026: 0, pen2025: 72, pen2026: 0 },
  { mes: "Octubre", unidades2025: 1014, unidades2026: 0, pen2025: 72, pen2026: 0 },
  { mes: "Noviembre", unidades2025: 1107, unidades2026: 0, pen2025: 70, pen2026: 0 },
  { mes: "Diciembre", unidades2025: 1260, unidades2026: 0, pen2025: 67, pen2026: 0 },
];

const coberturas = [
  { agencia: "MG Tollocan", llantas: 39, llaves: 32, amplia: 9, tren: 10, movilidad: 0 },
  { agencia: "MG Metepec", llantas: 42, llaves: 30, amplia: 3, tren: 0, movilidad: 0 },
  { agencia: "Nissan Aragón", llantas: 34, llaves: 2, amplia: 2, tren: 14, movilidad: 1 },
  { agencia: "Nissan Texcoco", llantas: 21, llaves: 12, amplia: 17, tren: 1, movilidad: 0 },
  { agencia: "MG Ecatepec", llantas: 29, llaves: 13, amplia: 6, tren: 0, movilidad: 0 },
  { agencia: "Nissan Santa Clara", llantas: 11, llaves: 10, amplia: 17, tren: 1, movilidad: 0 },
  { agencia: "Renault Universidad", llantas: 17, llaves: 9, amplia: 5, tren: 8, movilidad: 0 },
  { agencia: "Renault San Ángel", llantas: 4, llaves: 21, amplia: 7, tren: 2, movilidad: 3 },
];

const ChartCard = ({ title, subtitle, options, height = 340 }) => {
  const chartRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const finalOptions = {
      credits: { enabled: false },
      title: { text: null },
      ...options,
      chart: {
        backgroundColor: "transparent",
        height,
        ...(options.chart || {}),
      },
    };

    chartRef.current = Highcharts.chart(containerRef.current, finalOptions);

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [options, height]);

  return (
    <div className="card border-0 mb-3 facturacion-chart-card">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">{title}</h5>
          {subtitle && <p className="text-muted small mb-0">{subtitle}</p>}
        </div>

        <div ref={containerRef} />
      </div>
    </div>
  );
};

const KpiCard = ({ title, value, subtitle, className = "" }) => {
  return (
    <div className="card border-0 mb-3 facturacion-kpi-card">
      <div className="card-body">
        <div className="text-muted small mb-1">{title}</div>
        <div className={`facturacion-kpi-value ${className}`}>{value}</div>
        {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
      </div>
    </div>
  );
};

const TabGroup = ({ tabs, active, onChange }) => {
  return (
    <div className="facturacion-tabs-card">
      <div className="facturacion-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            type="button"
            className={`facturacion-tab-btn ${
              active === tab.value ? "active" : ""
            }`}
            onClick={() => onChange(tab.value)}
          >
            <span className="facturacion-tab-title">{tab.label}</span>
            {tab.subtitle && (
              <span className="facturacion-tab-subtitle">{tab.subtitle}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

const FilterBar = ({
  filtros,
  setFiltros,
  agencias,
  razonesSociales,
  tiposProducto,
  brokersOptions,
  onClear,
}) => {
  const update = (key, value) => {
    setFiltros((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
          <div>
            <h5 className="mb-1">Filtros</h5>
            <p className="text-muted small mb-0">
              Segmenta la información del dashboard por periodo, agencia,
              producto o broker.
            </p>
          </div>

          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onClear}
          >
            Limpiar filtros
          </button>
        </div>

        <div className="row g-2">
          <div className="col-xl-2 col-lg-3 col-md-4">
            <label className="form-label small text-muted mb-1">Año</label>
            <select
              className="form-select form-select-sm"
              value={filtros.anio}
              onChange={(event) => update("anio", event.target.value)}
            >
              <option value={ALL}>Todos</option>
              <option value="2026">2026</option>
              <option value="2025">2025</option>
            </select>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-4">
            <label className="form-label small text-muted mb-1">Mes</label>
            <select
              className="form-select form-select-sm"
              value={filtros.mes}
              onChange={(event) => update("mes", event.target.value)}
            >
              <option value={ALL}>Todos</option>
              {[
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
              ].map((mes) => (
                <option key={mes} value={mes}>
                  {mes}
                </option>
              ))}
            </select>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-4">
            <label className="form-label small text-muted mb-1">
              Departamento
            </label>
            <select
              className="form-select form-select-sm"
              value={filtros.departamento}
              onChange={(event) => update("departamento", event.target.value)}
            >
              <option value={ALL}>Todos</option>
              <option value="Nuevos">Nuevos</option>
              <option value="Seminuevos">Seminuevos</option>
            </select>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6">
            <label className="form-label small text-muted mb-1">Agencia</label>
            <select
              className="form-select form-select-sm"
              value={filtros.agencia}
              onChange={(event) => update("agencia", event.target.value)}
            >
              <option value={ALL}>Todas</option>
              {agencias.map((agencia) => (
                <option key={agencia} value={agencia}>
                  {agencia}
                </option>
              ))}
            </select>
          </div>

          <div className="col-xl-3 col-lg-6 col-md-6">
            <label className="form-label small text-muted mb-1">
              Razón social
            </label>
            <select
              className="form-select form-select-sm"
              value={filtros.razonSocial}
              onChange={(event) => update("razonSocial", event.target.value)}
            >
              <option value={ALL}>Todas</option>
              {razonesSociales.map((razon) => (
                <option key={razon} value={razon}>
                  {razon}
                </option>
              ))}
            </select>
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6">
            <label className="form-label small text-muted mb-1">
              Tipo de producto
            </label>
            <select
              className="form-select form-select-sm"
              value={filtros.tipoProducto}
              onChange={(event) => update("tipoProducto", event.target.value)}
            >
              <option value={ALL}>Todos</option>
              {tiposProducto.map((producto) => (
                <option key={producto} value={producto}>
                  {producto}
                </option>
              ))}
            </select>
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6">
            <label className="form-label small text-muted mb-1">Broker</label>
            <select
              className="form-select form-select-sm"
              value={filtros.broker}
              onChange={(event) => update("broker", event.target.value)}
            >
              <option value={ALL}>Todos</option>
              {brokersOptions.map((broker) => (
                <option key={broker} value={broker}>
                  {broker}
                </option>
              ))}
            </select>
          </div>

          <div className="col-xl-6 col-lg-4 col-md-12">
            <label className="form-label small text-muted mb-1">
              Búsqueda
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar agencia, asesor, producto, broker o vehículo"
              value={filtros.busqueda}
              onChange={(event) => update("busqueda", event.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const FacturacionGraficas = () => {
  const [tabPrincipal, setTabPrincipal] = useState("cierre");
  const [tabCierre, setTabCierre] = useState("resumen");
  const [tabOtros, setTabOtros] = useState("principal");

  const filtrosIniciales = {
    anio: "2026",
    mes: ALL,
    departamento: ALL,
    agencia: ALL,
    razonSocial: ALL,
    tipoProducto: ALL,
    broker: ALL,
    busqueda: "",
  };

  const [filtros, setFiltros] = useState(filtrosIniciales);

  const formatMoney = (value) => {
    const number = Number(value || 0);

    return number.toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
    });
  };

  const formatNumber = (value) => {
    const number = Number(value || 0);

    return number.toLocaleString("es-MX");
  };

  const formatMoneyShort = (value) => {
    const number = Number(value || 0);

    if (Math.abs(number) >= 1000000) {
      return `${(number / 1000000).toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} mill.`;
    }

    if (Math.abs(number) >= 1000) {
      return `${(number / 1000).toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} mil`;
    }

    return formatMoney(number);
  };

  const normalize = (value) => {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  };

  const agenciasOptions = useMemo(() => {
    return [...new Set(agenciasCierre.map((item) => item.agencia))].sort();
  }, []);

  const razonesSocialesOptions = useMemo(() => {
    return [...new Set(agenciasCierre.map((item) => item.razonSocial))].sort();
  }, []);

  const productosOptions = useMemo(() => {
    return [...new Set(productos.map((item) => item.producto))].sort();
  }, []);

  const brokersOptions = useMemo(() => {
    return [...new Set(brokers.map((item) => item.broker))].sort();
  }, []);

  const agenciasFiltradas = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return agenciasCierre.filter((item) => {
      const coincideDepartamento =
        filtros.departamento === ALL || item.departamento === filtros.departamento;

      const coincideAgencia =
        filtros.agencia === ALL || item.agencia === filtros.agencia;

      const coincideRazon =
        filtros.razonSocial === ALL || item.razonSocial === filtros.razonSocial;

      const coincideBusqueda =
        !texto ||
        normalize(item.agencia).includes(texto) ||
        normalize(item.razonSocial).includes(texto);

      return (
        coincideDepartamento &&
        coincideAgencia &&
        coincideRazon &&
        coincideBusqueda
      );
    });
  }, [filtros]);

  const productosFiltrados = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return productos.filter((item) => {
      const coincideProducto =
        filtros.tipoProducto === ALL || item.producto === filtros.tipoProducto;

      const coincideBusqueda =
        !texto || normalize(item.producto).includes(texto);

      return coincideProducto && coincideBusqueda;
    });
  }, [filtros]);

  const brokersFiltrados = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return brokers.filter((item) => {
      const coincideBroker =
        filtros.broker === ALL || item.broker === filtros.broker;

      const coincideBusqueda =
        !texto || normalize(item.broker).includes(texto);

      return coincideBroker && coincideBusqueda;
    });
  }, [filtros]);

  const otrosMensualFiltrado = useMemo(() => {
    return otrosMensual.filter((item) => {
      const coincideAnio = filtros.anio === ALL || item.anio === filtros.anio;
      const coincideMes = filtros.mes === ALL || item.mes === filtros.mes;

      return coincideAnio && coincideMes;
    });
  }, [filtros.anio, filtros.mes]);

  const conceptosOtrosFiltrados = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return conceptosOtros.filter((item) => {
      const coincideConcepto =
        filtros.tipoProducto === ALL ||
        normalize(item.concepto) === normalize(filtros.tipoProducto) ||
        normalize(item.concepto).includes(normalize(filtros.tipoProducto));

      const coincideBusqueda =
        !texto || normalize(item.concepto).includes(texto);

      return coincideConcepto && coincideBusqueda;
    });
  }, [filtros]);

  const asesoresFiltrados = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return asesoresRanking.filter((item) => {
      const coincideAgencia =
        filtros.agencia === ALL || item.agencia === filtros.agencia;

      const coincideBusqueda =
        !texto ||
        normalize(item.asesor).includes(texto) ||
        normalize(item.agencia).includes(texto);

      return coincideAgencia && coincideBusqueda;
    });
  }, [filtros]);

  const vehiculosFiltrados = useMemo(() => {
    const texto = normalize(filtros.busqueda);

    return vehiculosRanking.filter((item) => {
      const coincideAgencia =
        filtros.agencia === ALL || item.agencia === filtros.agencia;

      const coincideBusqueda =
        !texto ||
        normalize(item.vehiculo).includes(texto) ||
        normalize(item.agencia).includes(texto);

      return coincideAgencia && coincideBusqueda;
    });
  }, [filtros]);

  const coberturasFiltradas = useMemo(() => {
    return coberturas.filter((item) => {
      return filtros.agencia === ALL || item.agencia === filtros.agencia;
    });
  }, [filtros.agencia]);

  const pmaMensualFiltrado = useMemo(() => {
    return pmaMensual.filter((item) => {
      return filtros.mes === ALL || item.mes === filtros.mes;
    });
  }, [filtros.mes]);

  const resumenGeneral = useMemo(() => {
    const utilidadTotal = agenciasFiltradas.reduce(
      (total, item) => total + item.utilidad,
      0,
    );

    const unidadesTotal = agenciasFiltradas.reduce(
      (total, item) => total + item.unidades,
      0,
    );

    const financiamientosTotal = agenciasFiltradas.reduce(
      (total, item) => total + item.financiamiento,
      0,
    );

    const productosVendidos = productosFiltrados.reduce(
      (total, item) => total + item.cantidad,
      0,
    );

    const otrosUtilidad = otrosMensualFiltrado.reduce(
      (total, item) => total + item.utilidad,
      0,
    );

    const otrosProductos = otrosMensualFiltrado.reduce(
      (total, item) => total + item.productos,
      0,
    );

    const otrosUnidades = otrosMensualFiltrado.reduce(
      (total, item) => total + item.unidades,
      0,
    );

    return {
      utilidadTotal,
      unidadesTotal,
      financiamientosTotal,
      productosVendidos,
      penetracionFinanciamiento:
        unidadesTotal > 0 ? (financiamientosTotal / unidadesTotal) * 100 : 0,
      ticketPromedio: unidadesTotal > 0 ? utilidadTotal / unidadesTotal : 0,
      productosPorUnidad: unidadesTotal > 0 ? productosVendidos / unidadesTotal : 0,
      otrosUtilidad,
      otrosProductos,
      otrosUnidades,
      otrosTicketCBonos: otrosUnidades > 0 ? otrosUtilidad / otrosUnidades : 0,
      otrosRatio: otrosUnidades > 0 ? otrosProductos / otrosUnidades : 0,
    };
  }, [
    agenciasFiltradas,
    productosFiltrados,
    otrosMensualFiltrado,
  ]);

  const chartOptions = useMemo(() => {
    const agenciasBase =
      agenciasFiltradas.length > 0 ? agenciasFiltradas : [];

    const productosBase =
      productosFiltrados.length > 0 ? productosFiltrados : [];

    const brokersBase =
      brokersFiltrados.length > 0 ? brokersFiltrados : [];

    const conceptosBase =
      conceptosOtrosFiltrados.length > 0 ? conceptosOtrosFiltrados : [];

    const asesoresBase =
      asesoresFiltrados.length > 0 ? asesoresFiltrados : [];

    const vehiculosBase =
      vehiculosFiltrados.length > 0 ? vehiculosFiltrados : [];

    const mensualBase =
      otrosMensualFiltrado.length > 0 ? otrosMensualFiltrado : [];

    const topAgenciasUtilidad = [...agenciasBase]
      .sort((a, b) => b.utilidad - a.utilidad)
      .slice(0, 12);

    const topPenetracion = [...agenciasBase]
      .sort((a, b) => b.penetracion - a.penetracion)
      .slice(0, 12);

    return {
      unidadesVsFinanciamiento: {
        chart: { type: "column" },
        xAxis: {
          categories: agenciasBase.slice(0, 12).map((item) => item.agencia),
          labels: { rotation: -35, style: { fontSize: "11px" } },
        },
        yAxis: { min: 0, title: { text: "Unidades" } },
        tooltip: { shared: true },
        plotOptions: { column: { borderRadius: 3 } },
        series: [
          {
            name: "Unidades facturadas",
            data: agenciasBase.slice(0, 12).map((item) => item.unidades),
          },
          {
            name: "Financiamiento",
            data: agenciasBase.slice(0, 12).map((item) => item.financiamiento),
          },
          {
            name: "Ventas contado",
            data: agenciasBase.slice(0, 12).map((item) => item.contado),
          },
        ],
      },

      utilidadPorAgencia: {
        chart: { type: "bar" },
        xAxis: {
          categories: topAgenciasUtilidad.map((item) => item.agencia),
          title: { text: null },
        },
        yAxis: {
          min: 0,
          title: { text: "Utilidad bruta" },
          labels: {
            formatter: function () {
              return formatMoneyShort(this.value);
            },
          },
        },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatMoney(this.y)}</b>`;
          },
        },
        series: [
          {
            name: "Utilidad bruta",
            data: topAgenciasUtilidad.map((item) => item.utilidad),
          },
        ],
      },

      presupuestoAgencia: {
        chart: { type: "bar" },
        xAxis: {
          categories: topAgenciasUtilidad.map((item) => item.agencia),
        },
        yAxis: {
          min: 0,
          max: 150,
          title: { text: "% Presupuesto" },
          labels: { format: "{value}%" },
          plotLines: [
            {
              value: 100,
              width: 2,
              dashStyle: "Dash",
              label: { text: "Meta 100%" },
            },
          ],
        },
        tooltip: { pointFormat: "<b>{point.y}%</b>" },
        series: [
          {
            name: "Ppto vs U. Bruta",
            data: topAgenciasUtilidad.map((item) => item.ppto),
          },
        ],
      },

      penetracionPorAgencia: {
        chart: { type: "column" },
        xAxis: {
          categories: topPenetracion.map((item) => item.agencia),
          labels: { rotation: -35, style: { fontSize: "11px" } },
        },
        yAxis: {
          min: 0,
          title: { text: "% Penetración" },
          labels: { format: "{value}%" },
        },
        tooltip: { pointFormat: "<b>{point.y}%</b>" },
        series: [
          {
            name: "Penetración productos vs unidades",
            data: topPenetracion.map((item) => item.penetracion),
          },
        ],
      },

      penetracionGeneral: {
        chart: { type: "pie" },
        tooltip: { pointFormat: "<b>{point.percentage:.2f}%</b>" },
        plotOptions: {
          pie: {
            innerSize: "68%",
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.percentage:.1f}%",
            },
          },
        },
        series: [
          {
            name: "Penetración",
            data: [
              { name: "Financiamiento", y: resumenGeneral.penetracionFinanciamiento },
              { name: "Unidad sin adicionales", y: 11.53 },
              {
                name: "Resto",
                y: Math.max(
                  0,
                  100 - resumenGeneral.penetracionFinanciamiento - 11.53,
                ),
              },
            ],
          },
        ],
      },

      coberturasPorAgencia: {
        chart: { type: "column" },
        xAxis: {
          categories: coberturasFiltradas.map((item) => item.agencia),
          labels: { rotation: -35, style: { fontSize: "11px" } },
        },
        yAxis: {
          min: 0,
          title: { text: "Cantidad" },
          stackLabels: { enabled: true },
        },
        tooltip: { shared: true },
        plotOptions: {
          column: { stacking: "normal", borderRadius: 3 },
        },
        series: [
          { name: "Cobertura Llantas", data: coberturasFiltradas.map((item) => item.llantas) },
          { name: "Cobertura Llaves", data: coberturasFiltradas.map((item) => item.llaves) },
          { name: "Mecánica Amplia", data: coberturasFiltradas.map((item) => item.amplia) },
          { name: "Tren Motriz", data: coberturasFiltradas.map((item) => item.tren) },
          { name: "Movilidad", data: coberturasFiltradas.map((item) => item.movilidad) },
        ],
      },

      colocacionPorProducto: {
        chart: { type: "pie" },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatNumber(this.y)} productos</b>`;
          },
        },
        plotOptions: {
          pie: {
            innerSize: "45%",
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.y}",
            },
          },
        },
        series: [
          {
            name: "Productos vendidos",
            data: productosBase.map((item) => ({
              name: item.producto,
              y: item.cantidad,
            })),
          },
        ],
      },

      utilidadPorProducto: {
        chart: { type: "column" },
        xAxis: {
          categories: productosBase.map((item) => item.producto),
          labels: { rotation: -35, style: { fontSize: "11px" } },
        },
        yAxis: {
          min: 0,
          title: { text: "Utilidad bruta" },
          labels: {
            formatter: function () {
              return formatMoneyShort(this.value);
            },
          },
        },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatMoney(this.y)}</b>`;
          },
        },
        series: [
          {
            name: "Utilidad bruta",
            data: productosBase.map((item) => item.utilidad),
          },
        ],
      },

      brokerCantidad: {
        chart: { type: "column" },
        xAxis: {
          categories: brokersBase.map((item) => item.broker),
          labels: { rotation: -35 },
        },
        yAxis: { min: 0, title: { text: "Cantidad" } },
        series: [
          {
            name: "Cantidad",
            data: brokersBase.map((item) => item.cantidad),
          },
        ],
      },

      otrosUtilidadMensual: {
        chart: { type: "column" },
        xAxis: {
          categories: mensualBase.map((item) => item.mes),
        },
        yAxis: [
          {
            title: { text: "Utilidad bruta" },
            labels: {
              formatter: function () {
                return formatMoneyShort(this.value);
              },
            },
          },
          {
            title: { text: "Productos" },
            opposite: true,
          },
        ],
        tooltip: { shared: true },
        plotOptions: { column: { borderRadius: 3 } },
        series: [
          {
            name: "Utilidad bruta",
            type: "column",
            data: mensualBase.map((item) => item.utilidad),
          },
          {
            name: "Vts x producto",
            type: "spline",
            yAxis: 1,
            data: mensualBase.map((item) => item.productos),
          },
        ],
      },

      ticketsMensuales: {
        chart: { type: "spline" },
        xAxis: {
          categories: mensualBase.map((item) => item.mes),
        },
        yAxis: {
          title: { text: "Ticket" },
          labels: {
            formatter: function () {
              return formatMoneyShort(this.value);
            },
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        series: [
          {
            name: "Ticket S/Bono",
            data: mensualBase.map((item) => item.ticketSBono),
          },
          {
            name: "Ticket C/Bonos",
            data: mensualBase.map((item) => item.ticketCBonos),
          },
        ],
      },

      conceptosUtilidad: {
        chart: { type: "bar" },
        xAxis: {
          categories: conceptosBase.map((item) => item.concepto),
        },
        yAxis: {
          title: { text: "Utilidad bruta" },
          labels: {
            formatter: function () {
              return formatMoneyShort(this.value);
            },
          },
        },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatMoney(this.y)}</b>`;
          },
        },
        series: [
          {
            name: "Utilidad bruta",
            data: conceptosBase.map((item) => item.utilidad),
          },
        ],
      },

      conceptosProductos: {
        chart: { type: "pie" },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatNumber(this.y)} productos</b>`;
          },
        },
        plotOptions: {
          pie: {
            innerSize: "60%",
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.y}",
            },
          },
        },
        series: [
          {
            name: "Productos",
            data: conceptosBase.map((item) => ({
              name: item.concepto,
              y: item.productos,
            })),
          },
        ],
      },

      rankingAsesores: {
        chart: { type: "bar" },
        xAxis: {
          categories: asesoresBase.map((item) => item.asesor),
          labels: { style: { fontSize: "10px" } },
        },
        yAxis: {
          min: 0,
          title: { text: "Productos vendidos" },
        },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatNumber(this.y)} productos</b>`;
          },
        },
        series: [
          {
            name: "Productos vendidos",
            data: asesoresBase.map((item) => item.productos),
          },
        ],
      },

      rankingVehiculos: {
        chart: { type: "pie" },
        tooltip: {
          pointFormatter: function () {
            return `<b>${formatNumber(this.y)} productos</b>`;
          },
        },
        plotOptions: {
          pie: {
            innerSize: "55%",
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.y}",
            },
          },
        },
        series: [
          {
            name: "Vehículos",
            data: vehiculosBase.map((item) => ({
              name: item.vehiculo,
              y: item.productos,
            })),
          },
        ],
      },

      pmaMensual: {
        chart: { zoomType: "xy" },
        xAxis: {
          categories: pmaMensualFiltrado.map((item) => item.mes),
        },
        yAxis: [
          {
            title: { text: "Unidades" },
          },
          {
            title: { text: "Penetración" },
            labels: { format: "{value}%" },
            opposite: true,
          },
        ],
        tooltip: { shared: true },
        series: [
          {
            name: "Unidades 2025",
            type: "column",
            data: pmaMensualFiltrado.map((item) => item.unidades2025),
          },
          {
            name: "Unidades 2026",
            type: "column",
            data: pmaMensualFiltrado.map((item) => item.unidades2026),
          },
          {
            name: "Penetración 2025",
            type: "spline",
            yAxis: 1,
            data: pmaMensualFiltrado.map((item) => item.pen2025),
            tooltip: { valueSuffix: "%" },
          },
          {
            name: "Penetración 2026",
            type: "spline",
            yAxis: 1,
            data: pmaMensualFiltrado.map((item) => item.pen2026),
            tooltip: { valueSuffix: "%" },
          },
        ],
      },
    };
  }, [
    agenciasFiltradas,
    productosFiltrados,
    brokersFiltrados,
    otrosMensualFiltrado,
    conceptosOtrosFiltrados,
    asesoresFiltrados,
    vehiculosFiltrados,
    coberturasFiltradas,
    pmaMensualFiltrado,
    resumenGeneral,
  ]);

  const resetFiltros = () => {
    setFiltros(filtrosIniciales);
  };

  const renderSinDatos = () => (
    <div className="card border-0 mb-3">
      <div className="card-body text-center py-5">
        <h5 className="mb-1">Sin información</h5>
        <p className="text-muted mb-0">
          No se encontraron registros con los filtros aplicados.
        </p>
      </div>
    </div>
  );

  const renderTablaAgencias = () => (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">Utilidad bruta por agencia</h5>
          <p className="text-muted small mb-0">
            Resumen de utilidad, unidades y presupuesto por agencia.
          </p>
        </div>

        <div className="table-responsive facturacion-table-wrapper">
          <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "1100px" }}>
            <thead className="facturacion-table-head">
              <tr>
                <th>Agencia</th>
                <th>Razón social</th>
                <th>Departamento</th>
                <th className="text-end">Utilidad bruta</th>
                <th className="text-end">% vs total</th>
                <th className="text-end">Unidades</th>
                <th className="text-end">Financiamiento</th>
                <th className="text-end">Penetración</th>
                <th className="text-end">Ppto vs U. Bruta</th>
              </tr>
            </thead>

            <tbody>
              {agenciasFiltradas.map((row) => {
                const porcentaje =
                  resumenGeneral.utilidadTotal > 0
                    ? (row.utilidad / resumenGeneral.utilidadTotal) * 100
                    : 0;

                return (
                  <tr key={row.agencia}>
                    <td>{row.agencia}</td>
                    <td>{row.razonSocial}</td>
                    <td>{row.departamento}</td>
                    <td className="text-end">{formatMoney(row.utilidad)}</td>
                    <td className="text-end">{porcentaje.toFixed(2)}%</td>
                    <td className="text-end">{row.unidades}</td>
                    <td className="text-end">{row.financiamiento}</td>
                    <td className="text-end">{row.penetracion}%</td>
                    <td className="text-end">{row.ppto}%</td>
                  </tr>
                );
              })}
            </tbody>

            <tfoot>
              <tr>
                <th colSpan="3">Total</th>
                <th className="text-end">{formatMoney(resumenGeneral.utilidadTotal)}</th>
                <th className="text-end">100%</th>
                <th className="text-end">{formatNumber(resumenGeneral.unidadesTotal)}</th>
                <th className="text-end">{formatNumber(resumenGeneral.financiamientosTotal)}</th>
                <th className="text-end">{resumenGeneral.penetracionFinanciamiento.toFixed(0)}%</th>
                <th className="text-end">92%</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

  const renderTablaProductos = () => (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">Resultado por tipo de producto</h5>
          <p className="text-muted small mb-0">
            Utilidad bruta, productos vendidos y penetración por producto.
          </p>
        </div>

        <div className="table-responsive facturacion-table-wrapper">
          <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "950px" }}>
            <thead className="facturacion-table-head">
              <tr>
                <th>Tipo de producto</th>
                <th className="text-end">Utilidad bruta</th>
                <th className="text-end">% vs total</th>
                <th className="text-end">Productos vendidos</th>
                <th className="text-end">Penetración</th>
              </tr>
            </thead>

            <tbody>
              {productosFiltrados.map((row) => {
                const porcentaje =
                  resumenGeneral.utilidadTotal > 0
                    ? (row.utilidad / resumenGeneral.utilidadTotal) * 100
                    : 0;

                return (
                  <tr key={row.producto}>
                    <td>{row.producto}</td>
                    <td className="text-end">{formatMoney(row.utilidad)}</td>
                    <td className="text-end">{porcentaje.toFixed(2)}%</td>
                    <td className="text-end">{formatNumber(row.cantidad)}</td>
                    <td className="text-end">{row.penetracion}%</td>
                  </tr>
                );
              })}
            </tbody>

            <tfoot>
              <tr>
                <th>Total</th>
                <th className="text-end">
                  {formatMoney(
                    productosFiltrados.reduce(
                      (total, item) => total + item.utilidad,
                      0,
                    ),
                  )}
                </th>
                <th className="text-end">100%</th>
                <th className="text-end">
                  {formatNumber(
                    productosFiltrados.reduce(
                      (total, item) => total + item.cantidad,
                      0,
                    ),
                  )}
                </th>
                <th className="text-end">335%</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

  const renderTablaAsesores = () => (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">Ranking ventas de adicionales por asesor</h5>
          <p className="text-muted small mb-0">
            Productos vendidos, participación y utilidad facturada.
          </p>
        </div>

        <div className="table-responsive facturacion-table-wrapper">
          <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "1000px" }}>
            <thead className="facturacion-table-head">
              <tr>
                <th>Ranking</th>
                <th>Asesor</th>
                <th>Agencia</th>
                <th className="text-end">Productos vendidos</th>
                <th className="text-end">% Participación</th>
                <th className="text-end">Utilidad facturada</th>
              </tr>
            </thead>

            <tbody>
              {asesoresFiltrados.map((row, index) => (
                <tr key={row.asesor}>
                  <td>{index + 1}</td>
                  <td>{row.asesor}</td>
                  <td>{row.agencia}</td>
                  <td className="text-end">{row.productos}</td>
                  <td className="text-end">{row.participacion.toFixed(2)}%</td>
                  <td className="text-end">{formatMoney(row.utilidad)}</td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <th colSpan="3">Total</th>
                <th className="text-end">
                  {formatNumber(
                    asesoresFiltrados.reduce(
                      (total, item) => total + item.productos,
                      0,
                    ),
                  )}
                </th>
                <th className="text-end">100%</th>
                <th className="text-end">
                  {formatMoney(
                    asesoresFiltrados.reduce(
                      (total, item) => total + item.utilidad,
                      0,
                    ),
                  )}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

  const renderTablaVehiculos = () => (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">Ranking por vehículo o producto</h5>
          <p className="text-muted small mb-0">
            Productos vendidos por vehículo y agencia.
          </p>
        </div>

        <div className="table-responsive facturacion-table-wrapper">
          <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "800px" }}>
            <thead className="facturacion-table-head">
              <tr>
                <th>Vehículo o producto</th>
                <th>Agencia</th>
                <th className="text-end">Productos vendidos</th>
              </tr>
            </thead>

            <tbody>
              {vehiculosFiltrados.map((row) => (
                <tr key={`${row.vehiculo}-${row.agencia}`}>
                  <td>{row.vehiculo}</td>
                  <td>{row.agencia}</td>
                  <td className="text-end">{formatNumber(row.productos)}</td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <th colSpan="2">Total</th>
                <th className="text-end">
                  {formatNumber(
                    vehiculosFiltrados.reduce(
                      (total, item) => total + item.productos,
                      0,
                    ),
                  )}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

  const renderTablaConceptosOtros = () => (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-1">Utilidad bruta por concepto</h5>
          <p className="text-muted small mb-0">
            Desglose de utilidad bruta y ventas por producto.
          </p>
        </div>

        <div className="table-responsive facturacion-table-wrapper">
          <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "780px" }}>
            <thead className="facturacion-table-head">
              <tr>
                <th>Concepto</th>
                <th className="text-end">Utilidad bruta</th>
                <th className="text-end">Vts x producto</th>
              </tr>
            </thead>

            <tbody>
              {conceptosOtrosFiltrados.map((row) => (
                <tr key={row.concepto}>
                  <td>{row.concepto}</td>
                  <td className="text-end">{formatMoney(row.utilidad)}</td>
                  <td className="text-end">{formatNumber(row.productos)}</td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <th>Total</th>
                <th className="text-end">
                  {formatMoney(
                    conceptosOtrosFiltrados.reduce(
                      (total, item) => total + item.utilidad,
                      0,
                    ),
                  )}
                </th>
                <th className="text-end">
                  {formatNumber(
                    conceptosOtrosFiltrados.reduce(
                      (total, item) => total + item.productos,
                      0,
                    ),
                  )}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

  const renderCierreResumen = () => (
    <>
      {agenciasFiltradas.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Unidades facturadas"
                value={formatNumber(resumenGeneral.unidadesTotal)}
                subtitle="Periodo actual"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Financiamientos"
                value={formatNumber(resumenGeneral.financiamientosTotal)}
                subtitle={`${resumenGeneral.penetracionFinanciamiento.toFixed(
                  0,
                )}% penetración`}
                className="text-success"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Ventas contado"
                value={formatNumber(
                  resumenGeneral.unidadesTotal -
                    resumenGeneral.financiamientosTotal,
                )}
                subtitle="Unidades sin financiamiento"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Productos por unidad"
                value={resumenGeneral.productosPorUnidad.toFixed(2)}
                subtitle="Promedio general"
                className="text-primary"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-7">
              <ChartCard
                title="Unidades facturadas vs financiamiento"
                subtitle="Comparativo por agencia"
                options={chartOptions.unidadesVsFinanciamiento}
                height={390}
              />
            </div>

            <div className="col-xl-5">
              <ChartCard
                title="Ppto vs utilidad bruta"
                subtitle="Avance por agencia"
                options={chartOptions.presupuestoAgencia}
                height={390}
              />
            </div>
          </div>

          {renderTablaAgencias()}
        </>
      )}
    </>
  );

  const renderCierrePenetracion = () => (
    <>
      {agenciasFiltradas.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Penetración financiamiento"
                value={`${resumenGeneral.penetracionFinanciamiento.toFixed(0)}%`}
                subtitle="Productos colocados vs unidades"
                className="text-success"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Penetración Edega"
                value="55%"
                subtitle="Promedio general"
                className="text-primary"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Unidades sin adicionales"
                value="97"
                subtitle="9% vs facturadas"
                className="text-warning"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Productos colocados"
                value={formatNumber(resumenGeneral.productosVendidos)}
                subtitle="Total de productos"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-6">
              <ChartCard
                title="% Penetración general"
                subtitle="Financiamiento vs unidad sin adicionales"
                options={chartOptions.penetracionGeneral}
                height={330}
              />
            </div>

            <div className="col-xl-6">
              <ChartCard
                title="Penetración productos vs unidades"
                subtitle="Agencias con mayor penetración"
                options={chartOptions.penetracionPorAgencia}
                height={330}
              />
            </div>
          </div>

          <ChartCard
            title="Coberturas por agencia"
            subtitle="Distribución de coberturas colocadas"
            options={chartOptions.coberturasPorAgencia}
            height={390}
          />
        </>
      )}
    </>
  );

  const renderCierreDetalle = () => (
    <>
      {agenciasFiltradas.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Utilidad bruta general"
                value={formatMoneyShort(resumenGeneral.utilidadTotal)}
                subtitle="Total Gocar"
                className="text-success"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Ticket c/bonos"
                value={formatMoney(resumenGeneral.ticketPromedio)}
                subtitle="Promedio por unidad"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Ppto vs U. Bruta"
                value="92%"
                subtitle="Avance general"
                className="text-primary"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Productos vendidos"
                value={formatNumber(resumenGeneral.productosVendidos)}
                subtitle="Total general"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-7">
              <ChartCard
                title="Utilidad bruta por agencia"
                subtitle="Ranking de agencias"
                options={chartOptions.utilidadPorAgencia}
                height={430}
              />
            </div>

            <div className="col-xl-5">
              <ChartCard
                title="Colocación por tipo de producto"
                subtitle="Productos vendidos"
                options={chartOptions.colocacionPorProducto}
                height={430}
              />
            </div>
          </div>

          {renderTablaProductos()}
        </>
      )}
    </>
  );

  const renderOtrosPrincipal = () => (
    <>
      {otrosMensualFiltrado.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Utilidad Bruta más bonos"
                value={formatMoneyShort(resumenGeneral.otrosUtilidad)}
                subtitle="Acumulado"
                className="text-success"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Ticket C/Bonos"
                value={formatMoney(resumenGeneral.otrosTicketCBonos)}
                subtitle="Promedio acumulado"
                className="text-primary"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Ratio producto vs auto"
                value={resumenGeneral.otrosRatio.toFixed(2)}
                subtitle="Productos por unidad"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="% Crecimiento"
                value="2.73%"
                subtitle="Comparativo año anterior"
                className="text-success"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-7">
              <ChartCard
                title="Utilidad bruta y ventas por mes"
                subtitle="Año actual"
                options={chartOptions.otrosUtilidadMensual}
                height={390}
              />
            </div>

            <div className="col-xl-5">
              <ChartCard
                title="Ticket con bonos y sin bonos"
                subtitle="Tendencia mensual"
                options={chartOptions.ticketsMensuales}
                height={390}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-6">
              <ChartCard
                title="Utilidad bruta por concepto"
                subtitle="Desglose por tipo de producto"
                options={chartOptions.conceptosUtilidad}
                height={390}
              />
            </div>

            <div className="col-xl-6">
              <ChartCard
                title="Productos por concepto"
                subtitle="Participación por tipo de producto"
                options={chartOptions.conceptosProductos}
                height={390}
              />
            </div>
          </div>

          {renderTablaConceptosOtros()}
        </>
      )}
    </>
  );

  const renderOtrosRanking = () => (
    <>
      {asesoresFiltrados.length === 0 && vehiculosFiltrados.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-7">
              <ChartCard
                title="Ranking ventas de adicionales por asesor"
                subtitle="Productos vendidos por asesor"
                options={chartOptions.rankingAsesores}
                height={430}
              />
            </div>

            <div className="col-xl-5">
              <ChartCard
                title="Recuento de vehículo o producto"
                subtitle="Productos vendidos por vehículo"
                options={chartOptions.rankingVehiculos}
                height={430}
              />
            </div>
          </div>

          {renderTablaAsesores()}
          {renderTablaVehiculos()}
        </>
      )}
    </>
  );

  const renderOtrosComparativo = () => (
    <>
      {otrosMensualFiltrado.length === 0 ? (
        renderSinDatos()
      ) : (
        <>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Total año actual + año anterior"
                value="407 mill."
                subtitle="Indicador acumulado"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="2026 -Vs- 2025"
                value="13.71 mill."
                subtitle="Comparativo anual"
                className="text-primary"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="F&I Ticket"
                value="$10,989 mil"
                subtitle="Ticket promedio"
              />
            </div>

            <div className="col-xl-3 col-md-6">
              <KpiCard
                title="Crecimiento"
                value="2.73%"
                subtitle="Variación actual"
                className="text-success"
              />
            </div>
          </div>

          <ChartCard
            title="PMA - Unidades y penetración financiamiento"
            subtitle="Tendencia mensual 2025 vs 2026"
            options={chartOptions.pmaMensual}
            height={430}
          />

          <div className="card border-0 mb-3">
            <div className="card-body">
              <div className="mb-3">
                <h5 className="mb-1">Resumen mensual otros ingresos</h5>
                <p className="text-muted small mb-0">
                  Unidades, ventas por producto, utilidad, presupuesto y
                  tickets.
                </p>
              </div>

              <div className="table-responsive facturacion-table-wrapper">
                <table className="table table-hover align-middle facturacion-table" style={{ minWidth: "980px" }}>
                  <thead className="facturacion-table-head">
                    <tr>
                      <th>Mes</th>
                      <th className="text-end">Unidades vendidas</th>
                      <th className="text-end">Vts x producto</th>
                      <th className="text-end">Utilidad bruta</th>
                      <th className="text-end">Ppto vs U. Bruta</th>
                      <th className="text-end">Ticket S/Bono</th>
                      <th className="text-end">Ticket C/Bonos</th>
                    </tr>
                  </thead>

                  <tbody>
                    {otrosMensualFiltrado.map((row) => (
                      <tr key={row.mes}>
                        <td>{row.mes}</td>
                        <td className="text-end">{row.unidades}</td>
                        <td className="text-end">{row.productos}</td>
                        <td className="text-end">{formatMoney(row.utilidad)}</td>
                        <td className="text-end">{row.ppto}%</td>
                        <td className="text-end">
                          {formatMoney(row.ticketSBono)}
                        </td>
                        <td className="text-end">
                          {formatMoney(row.ticketCBonos)}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th>Total</th>
                      <th className="text-end">
                        {formatNumber(
                          otrosMensualFiltrado.reduce(
                            (total, item) => total + item.unidades,
                            0,
                          ),
                        )}
                      </th>
                      <th className="text-end">
                        {formatNumber(
                          otrosMensualFiltrado.reduce(
                            (total, item) => total + item.productos,
                            0,
                          ),
                        )}
                      </th>
                      <th className="text-end">
                        {formatMoney(
                          otrosMensualFiltrado.reduce(
                            (total, item) => total + item.utilidad,
                            0,
                          ),
                        )}
                      </th>
                      <th className="text-end">128%</th>
                      <th className="text-end">$8,095.78</th>
                      <th className="text-end">$13,943.00</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
        <div>
          <h1 className="page-header mb-1">Gráficas Facturación</h1>
          <p className="text-muted mb-0">
            Indicadores de cierre, penetración y resultados de otros ingresos.
          </p>
        </div>

        <div className="text-muted small">
          Periodo: {filtros.mes === ALL ? "Todos los meses" : filtros.mes}{" "}
          {filtros.anio === ALL ? "" : filtros.anio}
        </div>
      </div>

      <TabGroup
        active={tabPrincipal}
        onChange={setTabPrincipal}
        tabs={[
          {
            value: "cierre",
            label: "Cierre al día",
            subtitle: "Resumen, penetración y cierre",
          },
          {
            value: "otros",
            label: "Resultados otros ingresos",
            subtitle: "Principal, ranking y comparativo",
          },
        ]}
      />

      <FilterBar
        filtros={filtros}
        setFiltros={setFiltros}
        agencias={agenciasOptions}
        razonesSociales={razonesSocialesOptions}
        tiposProducto={productosOptions}
        brokersOptions={brokersOptions}
        onClear={resetFiltros}
      />

      {tabPrincipal === "cierre" && (
        <>
          <TabGroup
            active={tabCierre}
            onChange={setTabCierre}
            tabs={[
              {
                value: "resumen",
                label: "Resumen RM",
                subtitle: "Unidades y financiamiento",
              },
              {
                value: "penetracion",
                label: "Penetración",
                subtitle: "Productos colocados",
              },
              {
                value: "cierre",
                label: "Cierre",
                subtitle: "Utilidad y presupuesto",
              },
            ]}
          />

          {tabCierre === "resumen" && renderCierreResumen()}
          {tabCierre === "penetracion" && renderCierrePenetracion()}
          {tabCierre === "cierre" && renderCierreDetalle()}
        </>
      )}

      {tabPrincipal === "otros" && (
        <>
          <TabGroup
            active={tabOtros}
            onChange={setTabOtros}
            tabs={[
              {
                value: "principal",
                label: "Principal",
                subtitle: "Utilidad, tickets y conceptos",
              },
              {
                value: "ranking",
                label: "Ranking asesores",
                subtitle: "Adicionales por asesor",
              },
              {
                value: "comparativo",
                label: "Comparativo anual",
                subtitle: "2026 vs 2025",
              },
            ]}
          />

          {tabOtros === "principal" && renderOtrosPrincipal()}
          {tabOtros === "ranking" && renderOtrosRanking()}
          {tabOtros === "comparativo" && renderOtrosComparativo()}
        </>
      )}
    </div>
  );
};

export default FacturacionGraficas;